import { STATUS } from '@/lib/constants/cspm'

const CLOUD_SECURITY = {
  DASHBOARD: {
    TITLE: 'Cloud Security Dashboard',
    PROVIDER: 'Provider',
    ACCOUNT: 'Account',
    STATUS_TITLE: 'Distribution by Status',
    SEVERITY_TITLE: 'by Severity',
    SECURITY_POSTURE_TRENDS_TITLE: 'Security Posture Trends',
    LAST_SCAN: 'Last scan',
    TOP_AFFECTED_REGIONS_TITLE: 'Top Affected Regions',
    TOP_AFFECTED_SERVICES_TITLE: 'Top Affected Services',
    TOP_AFFECTED_NO_DATA: 'No issues found',
    ALL_ACCOUNTS: 'All Accounts',
    SYSTEM_HEALTH: 'System Health',
    FAILED_OUT_OF: 'failed out of',
    TOTAL_ISSUES: 'Issues',
    PASSED_CHECKS: 'Passed Checks',
    FAILED_CHECKS: 'Failed Checks',
    CRITICAL_ISSUES: 'Critical Issues',
    TOP_REGION: 'Top Region',
    TOP_SERVICE: 'Top Service',
    ISSUES_LABEL: 'issues',
    PASSED_LABEL: 'Passed',
    FAILED_LABEL: 'Failed',
    STATUS: {
      [STATUS.PASSED]: 'Passed',
      [STATUS.FAILED]: 'Failed',
    },
  },
  MISCONFIGURATIONS: {
    TITLE: 'Security Findings',
    DETAIL_ERROR: 'The details of this finding could not be loaded. Please try again.',
    FILTER_BY_ACCOUNT_PROVIDER: 'Filter by Account & Provider',
    PROVIDER: 'Provider',
    ACCOUNT: 'Account',
    NO_FINDINGS_FOUND: 'No findings found',
    SEARCH_PLACEHOLDER: 'Search findings...',
    SUMMARY: 'Summary',
    FILTERS: {
      PROVIDERS: 'Providers',
      ACCOUNTS: 'Accounts',
      SERVICES: 'Services',
      REGIONS: 'Regions',
    },
    STATUS: {
      OPEN: 'Failed',
      CLOSED: 'Passed',
      MUTED: 'Muted',
    },
    ATTRIBUTES: {
      ACCOUNT: 'Account',
      CLI_COMMAND: 'CLI Command',
      DATE_DETECTED: 'Date Detected',
      DESCRIPTION: 'Description',
      FINDING_NAME: 'Finding',
      LAST_DETECTED: 'Last Detected',
      LAST_UPDATED: 'Last Updated',
      OCCURRENCES: 'Occurrences',
      PROVIDER: 'Provider',
      RECOMMENDATION_URLS: 'Recommendation URLs',
      REGION: 'Region',
      REMEDIATION: 'Remediation',
      RESOURCE_ID: 'Resource ID',
      RESOURCE_NAME: 'Resource Name',
      RISK: 'Risk',
      SERVICE: 'Service',
      SEVERITY: 'Severity',
      STATUS: 'Status',
      TIMELINE: 'Timeline',
    },
    MONITORING: {
      LABEL: 'Monitoring',
    },
    MUTE: {
      MUTE_BUTTON: 'Mute finding',
      UNMUTE_BUTTON: 'Unmute finding',
      DIALOG_TITLE: 'Reason for mute',
      SELECTION_SUMMARY: (selected: number, total: number) => `${selected} of ${total} affected instances selected`,
      JUSTIFICATION_LABEL: 'Justification',
      JUSTIFICATION_PLACEHOLDER:
        'Why is this finding being muted? e.g. compensating control in place, accepted risk until Q4 migration',
      CANCEL: 'Cancel',
      BANNER_TITLE: (muted: number, total: number) => `Muted · ${muted} of ${total} affected instances`,
      MUTED_BADGE: 'Muted',
      MUTED_BY: (name: string) => `Muted by ${name}`,
      BY_SCANNER: 'Muted by the cloud scanner',
      NOTHING_SELECTED_TOOLTIP: 'Select at least one affected instance',
      DORMANT_NOTE: 'This mute will apply again if the finding fails in a future scan',
      MUTE_SUCCESS: 'Finding muted',
      UNMUTE_SUCCESS: 'Finding unmuted',
      MUTE_PARTIAL: (muted: number, requested: number) =>
        `Muted ${muted} of ${requested} instances — the rest are no longer open`,
      UNMUTE_PARTIAL: (unmuted: number, requested: number) =>
        `Unmuted ${unmuted} of ${requested} instances — the rest were no longer muted`,
      MUTE_ERROR: 'Could not mute the finding',
      UNMUTE_ERROR: 'Could not unmute the finding',
    },
  },
}
export default CLOUD_SECURITY
